export const getItem = (key: string) => {
  try {
    return window.localStorage.getItem(key);
  } catch (_e) {
    // pass
  }
  return null;
};

export const removeItem = (key: string) => {
  try {
    window.localStorage.removeItem(key);
  } catch (_e) {
    // pass
  }
};

export const getCurrentSystemUser = () => window.localStorage.currentSystemUser;

export const setItem = (key: string, value: string) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (_e) {
    // pass
  }
};
